// extracted by css-extract-rspack-plugin
export default {"container":"container--hWpwVrgWZkDJQjCZ","image":"image--TEKuUm62adkErCpe","description":"description--HQwFu1CYgAlBTbvk"};